import { useCallback, useContext } from "react";
import { ActionLayerKind, Layer } from "../reducers";
import { DateFilterContext } from "../context";

const useUpdateSelectOption = (layer, layerDispatcher, key) =>
  useCallback(
    items => {
      const item = items[0];

      if (item) {
        layerDispatcher({
          type: ActionLayerKind.UpdateLayer,
          payload: { data: { ...layer, [key]: item.value }, index: layer.uniqueId },
        });
      }
    },
    [layer, layerDispatcher, key],
  );

export const useCallbackLayerDispatchers = (layer: Layer) => {
  const { formLayerDispatcher: layerDispatcher } = useContext(DateFilterContext);

  const selectLayer = useCallback(
    items => {
      const item = items[0];

      if (item) {
        layerDispatcher({
          type: ActionLayerKind.UpdateLayer,
          payload: {
            data: { ...(item as Layer), uniqueId: layer.uniqueId, selected: layer.selected },
            index: layer.uniqueId,
          },
        });
      }
    },
    [layer, layerDispatcher],
  );

  const selectAttribute = useUpdateSelectOption(layer, layerDispatcher, "attribute");
  const selectAggregationAttribute = useUpdateSelectOption(layer, layerDispatcher, "aggregateAttr");
  const selectAggregationFunction = useUpdateSelectOption(layer, layerDispatcher, "aggregateFunc");

  const toogleAggregation = useCallback(() => {
    layerDispatcher({
      type: ActionLayerKind.UpdateLayer,
      payload: {
        data: { ...layer, isAggregated: !layer.isAggregated, aggregateAttr: "", aggregateFunc: null },
        index: layer.uniqueId,
      },
    });
  }, [layer, layerDispatcher]);

  const selectAggregationColor = useCallback(
    color => {
      if (color) {
        layerDispatcher({
          type: ActionLayerKind.UpdateLayer,
          payload: { data: { ...layer, aggregationColor: color }, index: layer.uniqueId },
        });
      }
    },
    [layer, layerDispatcher],
  );

  return {
    selectLayer,
    selectAttribute,
    toogleAggregation,
    selectAggregationAttribute,
    selectAggregationFunction,
    selectAggregationColor,
  };
};
